<template>
    <div>
        <v-card class="fill-height" elevation="0">
            <v-card-text>
                <Announcement type="home" />
            </v-card-text>
        </v-card> <br />
        <v-card class="fill-height" elevation="0">
            <v-card-text>
                <HomeCards />
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import Announcement from "../../../components/Student/Announcements/Announcement.vue"
import HomeCards from "../../../components/Student/Home/HomeCards.vue"

export default {
    components: {
        Announcement,
        HomeCards
    }
}
</script>